'use strict';

import formValidation from '../components/formValidation';
import birthdayHelpers from '../../../../scripts/helpers/birthdayHelpers';

const headerHeight = $('.cc-header').height() || 0;

function scrollToElement($message) {
    const scrollAnimateOffset = $message.offset().top - headerHeight - 100;
    $('html, body').animate({ scrollTop: scrollAnimateOffset }, 500);
}

function positionBelowHeader($element) {
    if (!$element || !$element.length) {
        return;
    }


    if (window.isDesktop) {
        var toastHeaderGap = 32;
    }
    else {
        var toastHeaderGap = - 24;
    }

    $element.css('margin-top', toastHeaderGap + 'px');
}

function togglePasswordVisibility(button) {
    var $button = $(button);
    var $wrapper = $button.closest('.cc-form__wrp');
    var $input = $wrapper.find('input[type="password"], input[type="text"]');
    var isVisible = $input.attr('type') === 'password';

    $input.attr('type', isVisible ? 'text' : 'password');
    $button.attr({
        'aria-label': isVisible ? $button.attr('data-hide-label') : $button.attr('data-show-label'),
        'aria-pressed': isVisible ? 'true' : 'false'
    });
    $button.find('.js-showPassword').toggleClass('d-none', isVisible);
    $button.find('.js-hidePassword').toggleClass('d-none', !isVisible);
}

$(document).on('click', '.js-passwordToggle', function () {
    togglePasswordVisibility(this);
});

function initDatePicker() {
  $('.js-dateInput').on('click', function() {
    var $dateInput = $('#registration-form-birthday');
    if ($dateInput.length) {
      if (typeof $dateInput[0].showPicker === 'function') {
        $dateInput[0].showPicker();
      } else {
        $dateInput.focus();
      }
    }
  });

  // Keyboard accessibility: trigger click on Enter or Space key
  $('.js-dateInput').on('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $(this).click();
    }
  });
}

initDatePicker();

var isBirthdayYearCheckEnabled = $('meta[name="is-birthday-year-check-enabled"]').attr('content') === 'true';
var isBirthdayAgeCheckEnabled = $('meta[name="is-birthday-age-check-enabled"]').attr('content') === 'true';

function isBirthdayValid(value) {
    return birthdayHelpers.isBirthdayValid(value, {
        isBirthdayYearCheckEnabled: isBirthdayYearCheckEnabled,
        isBirthdayAgeCheckEnabled: isBirthdayAgeCheckEnabled
    });
}

function showBirthdayError($input) {
    var errorMessage = $input.attr('data-age-error') || $input.attr('data-range-error') || '';
    $input.addClass('is-invalid');
    $input.closest('.cc-form__group').addClass('cc-error');
    $input.closest('.cc-form__group').find('.js-form-error').html(errorMessage);
}

function clearBirthdayError($input) {
    $input.removeClass('is-invalid');
    $input.closest('.cc-form__group').removeClass('cc-error');
    $input.closest('.cc-form__group').find('.js-form-error').empty();
}

function validateBirthdayYear() {
    var $birthdayInput = $('#registration-form-birthday');

    var today = new Date();
    var maxDate = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())).toISOString().split('T')[0];
    $birthdayInput.attr('max', maxDate);

    $birthdayInput.on('input change', function () {
        // Use setTimeout so this runs after formValidation's delegated clear handler
        setTimeout(function () {
            if ($birthdayInput.is(':disabled')) return;
            var currentValue = $birthdayInput.val();
            if ($birthdayInput[0].validity.badInput || (currentValue && !isBirthdayValid(currentValue))) {
                showBirthdayError($birthdayInput);
            } else {
                clearBirthdayError($birthdayInput);
            }
        }, 0);
    });
}

validateBirthdayYear();

// Field-level validation on blur
function validateFieldOnBlur() {
    // Exclude .js-sp selects — Bootstrap Select replaces the native UI so blur fires
    // on first tab-through before any real user interaction; those selects are handled
    // separately via hide.bs.select in validateSelectsOnClose()
    $('.cc-registration__form').on('blur', 'input[required], input[type="email"], select[required]:not(.js-sp)', function () {
        var $field = $(this);
        var $formGroup = $field.closest('.cc-form__group');
        var $errorElement = $formGroup.find('.js-form-error');
        var fieldValue = $field.val().trim();
        var fieldType = $field.attr('type');
        var fieldName = $field.attr('name');

        // Clear previous errors
        $field.removeClass('is-invalid');
        $formGroup.removeClass('cc-error');
        $errorElement.empty();

        // Skip if field is not visible or disabled
        if (!$field.is(':visible') || $field.is(':disabled')) {
            return;
        }

        var errorMessage = '';

        // Required field validation
        if (!errorMessage && $field.prop('required') && !fieldValue) {
            errorMessage = $field.attr('data-missing-error');
        }
        // Email validation
        else if (!errorMessage && (fieldType === 'email' || fieldName.indexOf('email') !== -1) && fieldValue) {
            var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(fieldValue)) {
                errorMessage = $field.attr('data-pattern-mismatch');
            }
        }
        // Password validation
        else if (!errorMessage && fieldName && fieldName.indexOf('password') !== -1 && !fieldName.indexOf('passwordconfirm') !== -1 && fieldValue) {
            if (fieldValue.length < 8 || fieldValue.length > 255) {
                errorMessage = $field.attr('data-range-error');
            }
        }
        // Birthday validation (year > 1900 and age >= 18)
        else if (!errorMessage && fieldType === 'date' && fieldValue) {
            if (isBirthdayValid(fieldValue) === false) {
                errorMessage = $field.attr('data-age-error') || $field.attr('data-range-error') || '';
            }
        }
        // Phone validation
        else if (!errorMessage && fieldType === 'tel' && fieldValue) {
            var phonePattern = /^[\d\s\-\+\(\)]+$/;
            if (!phonePattern.test(fieldValue)) {
                errorMessage = $field.attr('data-pattern-mismatch');
            }
        }
        // Password confirmation
        else if (!errorMessage && fieldName && fieldName.indexOf('passwordconfirm') !== -1 && fieldValue) {
            var $passwordField = $('input[name*="password"]:not([name*="confirm"]').first();
            if (fieldValue !== $passwordField.val()) {
                errorMessage = $field.attr('data-match-error');
            }
        }
        // Postal code validation
        else if (!errorMessage && fieldName && fieldName.indexOf('postalCode') !== -1 && fieldValue) {
            // Basic postal code validation (adjust pattern based on your needs)
            var postalPattern = /^[A-Za-z0-9\s\-]{3,10}$/;
            if (!postalPattern.test(fieldValue)) {
                errorMessage = $field.attr('data-pattern-mismatch');
            }
        }

        // Display error if validation failed
        if (errorMessage) {
            $field.addClass('is-invalid');
            $formGroup.addClass('cc-error');
            $errorElement.html(errorMessage);
        }
    });
}

// Initialize blur validation
validateFieldOnBlur();

// Field-level validation on blur for company fields (only when js-companyFlag is checked)
function validateCompanyFieldsOnBlur() {
    // Exclude .js-sp selects — Bootstrap Select replaces their UI, handled in validateSelectsOnClose()
    $('.cc-registration__form').on('blur', '.js-profileCompanyData input, .js-profileCompanyData select:not(.js-sp)', function () {
        if (!$('.js-companyFlag').is(':checked')) {
            return;
        }

        var $field = $(this);
        var $formGroup = $field.closest('.cc-form__group');
        var $errorElement = $formGroup.find('.js-form-error');
        var fieldValue = $field.val() ? $field.val().trim() : '';
        var fieldId = $field.attr('id');

        // Clear previous errors
        $field.removeClass('is-invalid');
        $formGroup.removeClass('cc-error');
        $errorElement.empty();

        var errorMessage = '';

        // Required check: rely on data-missing-error attribute since company fields
        // are conditionally required and may not have the HTML required attribute
        if (!fieldValue && $field.attr('data-missing-error')) {
            errorMessage = $field.attr('data-missing-error');
        }
        // companyName: max 50 chars
        else if (fieldId === 'registration-form-companyName' && fieldValue) {
            if (fieldValue.length > 50) {
                errorMessage = $field.attr('data-range-error');
            }
        }
        // companyVAT: basic EU VAT format (2-letter country code + 2-12 alphanumeric)
        else if (fieldId === 'registration-form-companyVAT' && fieldValue) {
            var vatPattern = new RegExp($field.attr('pattern'));
            if (!vatPattern.test(fieldValue.replace(/\s/g, ''))) {
                errorMessage = $field.attr('data-pattern-mismatch');
            }
        }
        // SIRET: exactly 14 digits
        else if (fieldId === 'registration-form-companySiret' && fieldValue) {
            var siretPattern = /^\d{14}$/;
            if (!siretPattern.test(fieldValue.replace(/\s/g, ''))) {
                errorMessage = $field.attr('data-pattern-mismatch');
            }
        }

        if (errorMessage) {
            $field.addClass('is-invalid');
            $formGroup.addClass('cc-error');
            $errorElement.html(errorMessage);
        }
    });
}

validateCompanyFieldsOnBlur();

// Validate Bootstrap Select (js-sp) fields on focus leaving the widget.
// Using focusout on the .bootstrap-select wrapper is reliable across tab-through
// and click-away, unlike hide.bs.select which has inconsistent bubbling.
// - country: validates whenever focus leaves (always required).
// - companyActivity: validates only after the user has explicitly opened the dropdown
//   once (tracked via show.bs.select), so no error appears on a plain tab-through.
function validateSelectsOnClose() {
    function validateSelect($field) {
        var $formGroup = $field.closest('.cc-form__group');
        var $errorElement = $formGroup.find('.js-form-error');
        $field.removeClass('is-invalid');
        $formGroup.removeClass('cc-error');
        $errorElement.empty();
        if (!$field.val() && $field.attr('data-missing-error')) {
            $field.addClass('is-invalid');
            $formGroup.addClass('cc-error');
            $errorElement.html($field.attr('data-missing-error'));
        }
    }

    // focusout bubbles, so delegation on document works reliably.
    // setTimeout ensures document.activeElement has settled on the next element.
    $(document).on('focusout', '.bootstrap-select', function () {
        var $bootstrapSelect = $(this);
        setTimeout(function () {
            // Skip if focus is still inside the widget or the dropdown is still open
            if ($bootstrapSelect.find(':focus').length || $bootstrapSelect.hasClass('open')) {
                return;
            }
            var $select = $bootstrapSelect.closest('.cc-form__wrp--select').find('select.js-sp');
            if (!$select.length) return;

            var selectId = $select.attr('id');

            if (selectId === 'country') {
                validateSelect($select);
            } else if (selectId === 'companyActivity') {
                if (!$('.js-companyFlag').is(':checked')) return;
                // Only validate if the user has opened the dropdown at least once
                if (!$select.data('bs-interacted')) return;
                validateSelect($select);
            }
        }, 50);
    });

    // Mark companyActivity as interacted when the user opens it OR tabs into it
    $(document).on('show.bs.select', '#companyActivity', function () {
        $(this).data('bs-interacted', true);
    });
    $(document).on('focusin', '.bootstrap-select', function () {
        var $select = $(this).closest('.cc-form__wrp--select').find('#companyActivity');
        if ($select.length) {
            $select.data('bs-interacted', true);
        }
    });

    // Clear error as soon as a valid value is picked
    $(document).on('change', '#country, #companyActivity', function () {
        if ($(this).val()) {
            var $field = $(this);
            $field.removeClass('is-invalid');
            $field.closest('.cc-form__group').removeClass('cc-error');
            $field.closest('.cc-form__group').find('.js-form-error').empty();
        }
    });
}

validateSelectsOnClose();

// Show/hide company data fields based on the company flag checkbox
function toggleCompanyFields(isChecked) {
    if (isChecked) {
        $('.js-profileCompanyData').removeClass('d-none');
        $('.js-birthdayData').addClass('d-none');
        $('#registration-form-birthday').prop('disabled', true);
    } else {
        $('.js-profileCompanyData').addClass('d-none');
        $('.js-birthdayData').removeClass('d-none');
        $('#registration-form-birthday').prop('disabled', false);
    }
}

// Enable/disable company fields based on the checkbox state
function toggleCompanyFieldsState(isChecked, field) {
    if (isChecked) {
        field.prop('disabled', true);
    } else {
        field.prop('disabled', false);
    }
}

$('.js-withoutVAT').on('change', function () {
    var isChecked = $(this).is(':checked');
    var $vatField = $('#registration-form-companyVAT');
    if (isChecked) {
        $vatField.val('');
    }
    toggleCompanyFieldsState(isChecked, $vatField);
});

function syncWithoutVATWithCompanyActivity () {
    var $companyActivity = $('#companyActivity');
    var $withoutVAT = $('#withoutVAT');
    var autoCheckedDataKey = 'auto-checked-by-company-activity';
    var vatExemptValues = [
        'association_or_sme_not_subject_to_vat',
        'self_employed_auto_entrepreneur_not_subject_to_vat',
        'business_being_created_waiting_for_vat_number'
    ];

    if (!$companyActivity.length || !$withoutVAT.length) {
        return;
    }

    function updateWithoutVAT () {
        var selectedValue = $companyActivity.val();
        var isVatExemptActivity = vatExemptValues.indexOf(selectedValue) !== -1;

        if (isVatExemptActivity && !$withoutVAT.prop('checked')) {
            $withoutVAT.data(autoCheckedDataKey, true);
            $withoutVAT.prop('checked', true).trigger('change');
        } else if (!isVatExemptActivity && $withoutVAT.data(autoCheckedDataKey)) {
            $withoutVAT.prop('checked', false).trigger('change');
            $withoutVAT.removeData(autoCheckedDataKey);
        }
    }

    $withoutVAT.on('change', function () {
        if (!$(this).prop('checked')) {
            $(this).removeData(autoCheckedDataKey);
        }
    });

    $companyActivity.on('changed.bs.select', updateWithoutVAT);
    updateWithoutVAT();
}

syncWithoutVATWithCompanyActivity();
$('.js-withoutSiret').on('change', function () {
    var isChecked = $(this).is(':checked');
    var $siretField = $('#registration-form-companySiret');
    if (isChecked) {
        $siretField.val('');
    }
    toggleCompanyFieldsState(isChecked, $siretField);
});

// On change
$('.js-companyFlag').on('change', function () {
    toggleCompanyFields($(this).is(':checked'));
});

$(() => {
    var isChecked = $('.js-companyFlag').is(':checked');
    toggleCompanyFields(isChecked);
});

/* Handle registration and login form submission via AJAX */


$(document).on('click', '.js-submitRegistration, .js-submitLogin', function (e) {
    e.preventDefault();

    var $button = $(this);
    var $form = $button.closest('form');

    // Validate birthday for registration forms
    if ($button.hasClass('js-submitRegistration')) {
        var $birthdayInput = $form.find('#registration-form-birthday');
        if ($birthdayInput.length && !$birthdayInput.is(':disabled')) {
            var birthdayValue = $birthdayInput.val();
            if ($birthdayInput[0].validity.badInput || (birthdayValue && !isBirthdayValid(birthdayValue))) {
                showBirthdayError($birthdayInput);
                $birthdayInput[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                return;
            }
        }
    }

    var url = $form.attr('action');
    var siteKey = $('meta[name="g-recaptcha"]').attr('content');
    var action = $button.hasClass('js-submitLogin') ? 'login' : 'registration';
    var isRecaptchaEnabled = $('meta[name="is-recaptcha-enabled"]').attr('content') === 'true';

    if (!isRecaptchaEnabled) {
        submitForm();
        return;
    }
    function submitForm () {
        $.ajax({
            url: url,
            type: 'POST',
            data: $form.serialize(),
            success: function (data) {
                $button.prop('disabled', false);
                if (!data.success) {
                    formValidation($form, data);
                } else {
                    if (data.dataLayer) window.dataLayer = data.dataLayer;
                    window.location.href = data.redirectUrl;
                }
            },
            error: function () {
                $button.prop('disabled', false);
            }
        });
    }

    grecaptcha.ready(function () {
        grecaptcha.execute(siteKey, { action: action }).then(function (token) {
            $form.find('input[name="g-recaptcha-response"]').val(token);

            $.ajax({
                url: url,
                type: 'POST',
                data: $form.serialize(), 
                success: function (data) {
                    $button.prop('disabled', false);
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        if (data.dataLayer) window.dataLayer = data.dataLayer;
                        window.location.href = data.redirectUrl;
                    }
                },
                error: function () {
                    $button.prop('disabled', false);
                }
            });
        });
    });
});

/* Handle password reset form submission via AJAX */
$(document).on('click', '#submitEmailButton', function (e) {
    var $form = $(this).closest('form');
    e.preventDefault();

    var url = $form.attr('action');
    $('#submitEmailButton').prop('disabled', true);
    $.ajax({
        url: url,
        type: 'POST',
        data: $form.serialize(),
        success: function (data) {
            $('#submitEmailButton').prop('disabled', false);

            if (!data.success) {
                formValidation($form, data);
            } else {
                positionBelowHeader($('.js-resetPasswordSuccessDesktop'));
                positionBelowHeader($('.js-resetPasswordSuccessMobile'));

                if(window.isDesktop) {
                    $('.js-resetPasswordSuccessDesktop').removeClass('d-none').addClass('d-flex');
                } else {
                    $('.js-resetPasswordSuccessMobile').removeClass('d-none');
                }

                if (data.returnUrl) {
                    setTimeout(function () {
                        window.location.href = data.returnUrl;
                    }, 3500);
                }
            }
        },
        error: function () {
            console.log('error');
            $('#submitEmailButton').prop('disabled', false);
            $('.js-resetPasswordSuccessDesktop, .js-resetPasswordSuccessMobile').addClass('d-none').removeClass('d-flex');
        }
    });
    return false;
});

$(document).on('click', '.js-hideSuccessMessage', function () {
    $('.js-resetPasswordSuccessDesktop, .js-resetPasswordSuccessMobile').addClass('d-none').removeClass('d-flex');
    $('.js-changePasswordSuccessDesktop').addClass('d-none').removeClass('d-lg-flex');
    $('.js-changePasswordSuccessMobile').addClass('d-none').removeClass('d-lg-none');
});


$(document).ready(function () {
    var $password = $('#newPassword');

    function validatePasswordConstraints(password) {
        return {
            length: password.length >= 8,
            uppercase: /[A-Z]/.test(password),
            lowercase: /[a-z]/.test(password),
            number: /[0-9]/.test(password),
        };
    }

    $password.on('input', function () {
        var val = $(this).val();
        var checks = validatePasswordConstraints(val);

        // Update each requirement's visual state
        $('.js-passwordLength').find('.js-passwordError').toggleClass('d-none', checks.length);
        $('.js-passwordLength').find('.js-passwordSuccess').toggleClass('d-none', !checks.length);
        $('.js-passwordUppercase').find('.js-passwordError').toggleClass('d-none', checks.uppercase);
        $('.js-passwordUppercase').find('.js-passwordSuccess').toggleClass('d-none', !checks.uppercase);
        $('.js-passwordLowercase').find('.js-passwordError').toggleClass('d-none', checks.lowercase);
        $('.js-passwordLowercase').find('.js-passwordSuccess').toggleClass('d-none', !checks.lowercase);
        $('.js-passwordNumber').find('.js-passwordError').toggleClass('d-none', checks.number);
        $('.js-passwordNumber').find('.js-passwordSuccess').toggleClass('d-none', !checks.number);
    });

    if ($('.js-changePasswordSuccessDesktop').length || $('.js-changePasswordSuccessMobile').length) {
        setTimeout(function () {
            $('.js-changePasswordSuccessDesktop').addClass('d-none').removeClass('d-lg-flex');
            $('.js-changePasswordSuccessMobile').addClass('d-none').removeClass('d-lg-none');
        }, 3500);
    }
});

//Handle change password alert banner slot dismissal
$(() => {
    var $banner = $('.js-alertBanner');

    if (sessionStorage.getItem('bannerDismissed') === 'true') {
        $banner.addClass('d-none');
    }
    else {
        $banner.removeClass('d-none');
    }

    $(document).on('click', '.js-closeAlertBanner', function () {
        $banner.addClass('d-none');
        sessionStorage.setItem('bannerDismissed', 'true');
    });
});

$(() => {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('showLoginSuccessToast') === 'true') {
        urlParams.delete('showLoginSuccessToast');
        var newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '') + window.location.hash;
        history.replaceState(null, '', newUrl);
        handleResponse();
    }
});

//Handle AJAX response globally
function handleResponse() {
    const $successToast = $('.js-successToast');

    if ($('body').hasClass('modal-open')) {
        $('body').find('.cc-modal.show').modal('hide');
    }

    $successToast.find('.cc-toast__title').text($successToast.find('.cc-toast__title').data('login-title'));
    $successToast.find('.cc-toast__text').text($successToast.find('.cc-toast__text').data('login-text'));

    // Position toast below header with a 16px gap
    $successToast.css('top', (headerHeight + toastHeaderGap) + 'px');

    $successToast.removeClass('d-none').addClass('show cc-registration__privilege__toast');

    scrollToElement($successToast);

    setTimeout(function () {
        $successToast.removeClass('show cc-registration__privilege__toast').addClass('d-none');
    }, 2500);

    setTimeout(function () {
        window.location.reload();
    }, 3000);
    $.spinner().stop();
}